import React, { useState } from "react";
import { BiMenuAltRight } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdKeyboardArrowUp } from "react-icons/md";
import navbarDataTH from "../../../languages/th/navbar.json";
import navbarDataEN from "../../../languages/en/navbar.json";
import { useLanguage } from "../../../context/LanguageContext";

const Navbar = ({ theme = "white" }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { selectedLanguage, setSelectedLanguage } = useLanguage(); // Use the context
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const currentPath = window.location.pathname;

  // Function to check if the link matches the current path
  const isCurrentPath = (linkPath) => {
    return currentPath === linkPath;
  };

  const toggleDropdownLang = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    setIsDropdownOpen(false);
  };

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    setIsSidebarOpen(false);
    setIsDropdownOpen(false);
    // You can add logic here to change the language setting in your app
  };
  const navbarData = selectedLanguage === "th" ? navbarDataTH : navbarDataEN;

  return (
    <div>
      {/* Main Content */}
      <nav
        className="p-4 flex items-center justify-between
      w-full text-white gap-2 h-20"
      >
        <img
          src={
            theme === "white"
              ? process.env.PUBLIC_URL +
                "/Logo/white_logo-navbar_mobile 134x35.png"
              : process.env.PUBLIC_URL +
                "/Logo/black_logo-navbar_mobile 134x35.png"
          }
          alt="Logo"
          className="h-8 w-auto mr-2"
        />

        {/* Language and Subscribe */}
        <div className="flex">
          <div
            className="flex items-center font-feature-settings-off 
          font-prompt font-medium cursor-pointer"
            onClick={toggleDropdownLang}
          >
            <img
              src={
                selectedLanguage === "th"
                  ? process.env.PUBLIC_URL + "/mian/languages/Thailand.svg"
                  : process.env.PUBLIC_URL + "/mian/languages/English.svg"
              }
              alt="Language"
              className="mr-2 w-8 "
            />
          </div>

          {isDropdownOpen && (
            <div
              className="absolute top-14 right-15 bg-white shadow-md rounded-md p-2 w-16
           "
            >
              <div
                className={`cursor-pointer relative text-gray-700 ${
                  selectedLanguage === "th" ? "text-primary-900 font-light" : ""
                }`}
                onClick={() => handleLanguageChange("th")}
              >
                <img
                  src={process.env.PUBLIC_URL + "/mian/languages/Thailand.svg"}
                  alt="Thai"
                  className="w-6 h-6 inline mr-2"
                />

                {selectedLanguage === "th" && (
                  <span className="absolute right-0 top-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      className=""
                    >
                      <path
                        d="M7.16172 13.5002L2.88672 9.22519L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z"
                        fill="#1DAB59"
                      />
                    </svg>
                  </span>
                )}
              </div>
              <div
                className={`cursor-pointer text-gray-700
               ${
                 selectedLanguage === "en" ? "text-primary-900 font-light" : ""
               }`}
                onClick={() => handleLanguageChange("en")}
              >
                <img
                  src={process.env.PUBLIC_URL + "/mian/languages/English.svg"}
                  alt="English"
                  className="w-6 h-6 inline mr-2"
                />

                {selectedLanguage === "en" && (
                  <span className="absolute right-2 bottom-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      className=""
                    >
                      <path
                        d="M7.16172 13.5002L2.88672 9.22519L3.95547 8.15645L7.16172 11.3627L14.043 4.48145L15.1117 5.5502L7.16172 13.5002Z"
                        fill="#1DAB59"
                      />
                    </svg>
                  </span>
                )}
              </div>
            </div>
          )}
          <button
            className={`mr-4 
            ${theme === "white" ? "text-white" : "text-black"}
            focus:outline-none`}
            onClick={toggleSidebar}
          >
            <BiMenuAltRight size={50} />
          </button>
        </div>
      </nav>

      {/* Sidebar */}
      <div
        className={`fixed top-0 right-0 bg-primary-dark h-full w-64 md:w-96 border-l 
                    z-30
        ${
          isSidebarOpen
            ? "transform translate-x-0 "
            : "transform translate-x-full"
        } transition-all duration-300 flex flex-col`}
      >
        <div className="flex justify-around items-center  py-2 mt-4 mx-6">
          <img
            src={
              process.env.PUBLIC_URL +
              "/Logo/white_logo-navbar_desktop 241x49.png"
            }
            alt="Logo"
            className="h-8 w-auto mr-4"
          />
          <button
            className="text-white focus:outline-none text-3xl"
            onClick={toggleSidebar}
          >
            x
          </button>
        </div>

        {/* Sidebar Content */}

        <ul className="pt-10 mx-4 flex-grow">
          <li className="mb-4 px-4 my-2 text-white cursor-pointer">
            <a
              className={`  cursor-pointer ${
                isCurrentPath("/") ? "text-primary-900" : ""
              }`}
              onClick={(e) => {
                e.preventDefault();
                navigate("/");
              }}
            >
              {navbarData.home}
            </a>
          </li>
          <hr className="border-secondary-900" />
          <li className="mb-4 px-4 my-2 text-white cursor-pointer">
            <a
              className={`  cursor-pointer ${
                isCurrentPath("/about") ? "text-primary-900" : ""
              }`}
              onClick={(e) => {
                window.location.href = "#about";
                setIsSidebarOpen(false);
              }}
            >
              {navbarData.about}
            </a>
          </li>
          <hr className="border-secondary-900" />

          <li className="mb-4 px-4 my-2 text-white cursor-pointer  ">
            <p
              onClick={() => {
                setIsDropdownOpen(!isDropdownOpen);
                setSelectedOption(null);
              }}
              className={`cursor-pointer flex justify-between items-center w-full ${
                isDropdownOpen ? "text-primary-900" : ""
              }`}
            >
              {navbarData.howto}
              {isDropdownOpen ? (
                <MdKeyboardArrowUp
                  size={30}
                  className="text-primary-900 flex"
                />
              ) : (
                <MdKeyboardArrowDown size={30} />
              )}
            </p>
            {isDropdownOpen && (
              <ul className="mt-2 w-full  ">
                {/* <li
                  className={`px-4 py-2 cursor-pointer ${
                    selectedOption === "option1"
                      ? "text-primary-900"
                      : "text-white"
                  }`}
                  onClick={() => {
                    setSelectedOption("option1");

                    window.open(
                      process.env.PUBLIC_URL + "/about%20us/Instructions.pdf"
                    );
                  }}
                >
                  {navbarData.mInstruction}
                </li> */}

                <li
                  className={`px-4 py-2 cursor-pointer ${
                    selectedOption === "option1"
                      ? "text-primary-900"
                      : "text-white"
                  }`}
                >
                  <a
                    href={
                      process.env.PUBLIC_URL + "/about%20us/Instructions.pdf"
                    }
                    target="_blank" // Open link in a new tab
                    rel="noopener noreferrer" // Recommended for security reasons
                  >
                    {navbarData.mInstruction}
                  </a>
                </li>
                <li
                  className={`px-4 py-2 cursor-pointer ${
                    selectedOption === "option2"
                      ? "text-primary-900"
                      : "text-white"
                  }`}
                  onClick={() => {
                    setSelectedOption("option2");
                    window.open(
                      "https://www.youtube.com/@chatnshops",
                      "_blank"
                    );
                  }}
                >
                  {navbarData.vInstruction}
                </li>
              </ul>
            )}
          </li>
          <hr className="border-secondary-900" />

          <li className="mb-4 px-4 my-2 text-white cursor-pointer">
            <a
              className={`  cursor-pointer
              ${isCurrentPath("/packages") ? "text-primary-900" : ""}`}
              onClick={(e) => {
                window.location.href = "#packages";
                setIsSidebarOpen(false);
              }}
            >
              {navbarData.packages}
            </a>
          </li>
          <div className="flex flex-col justify-end items-center w-full mt-12">
            <button
              className="bg-transparent text-white mb-5 px-4 py-2 rounded-3xl font-medium w-3/4
            border-2 border-secondary-900"
              onClick={(e) => {
                e.preventDefault();
                navigate("/login");
              }}
            >
              {navbarData.login}
            </button>

            <button
              className="bg-primary-900 text-white px-4 py-2 rounded-3xl font-medium w-3/4"
              onClick={(e) => {
                e.preventDefault();
                navigate("/register");
              }}
            >
              {navbarData.register}
            </button>
          </div>
        </ul>

        {/* footer */}
        <div
          className="flex justify-center bg-primary-dark text-primary-100
        text-xs py-2 px-4 text-center "
        >
          © Chatnshops Company. 2023 <br /> — All rights reserved.
        </div>
      </div>
    </div>
  );
};

export default Navbar;
